var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmesAnswered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#CCDDFF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54517 22.262L26.4071 14.0371C27.4145 13.578 28.5714 13.578 29.5789 14.0371L47.2843 22.1056C47.3637 22.1417 47.4209 22.2066 47.4492 22.2823C47.4775 22.358 47.4769 22.4445 47.4407 22.5238C47.4092 22.5931 47.3536 22.6487 47.2843 22.6802L29.5789 30.7487C28.5714 31.2078 27.4145 31.2078 26.407 30.7487L8.70158 22.6803C8.62223 22.6441 8.56505 22.5792 8.53674 22.5035C8.50844 22.4278 8.50901 22.3413 8.54517 22.262Z",
    stroke: "#2E6BE6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7384 20.8658C32.4024 23.0439 34.7345 25.225 34.7345 27.4092C34.7345 29.5934 34.7345 31.4901 34.7345 33.099",
    stroke: "#2E6BE6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3594 25.5777L41.3594 35.2174C41.3594 35.9047 40.958 36.5287 40.3325 36.8138L30.0981 41.4776C28.761 42.087 27.2252 42.087 25.8881 41.4776L15.6536 36.8138C15.0282 36.5287 14.6268 35.9047 14.6268 35.2174L14.6268 25.5777",
    stroke: "#2E6BE6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmesAnswered);
export default __webpack_public_path__ + "static/media/cmes-answered.edf334980aa92da9479464e7549941d4.svg";
export { ForwardRef as ReactComponent };